import angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";

export interface IServiceManager {
    getServiceTimeUnits();
    getTimeUnitsById(unitType: string, unitId: number);
    manageServices(page: string,reload?);
    viewCurrentService(serviceId:number,reload?);
    viewCurrentServiceNote(serviceNoteId:number , serviceId : number ,reload?);
}

export class ServiceManager implements IServiceManager {
    static $inject = ["$q", "CacheService", "ApiAdapterService", "$ocLazyLoad" , "$state"];
    constructor(private $q: ng.IQService,
        private $_cache: CacheService,
        private $_api: JavaApiAdapterService,
        private $ocLazyLoad ,
        private $state) {
    }

    // gets the time units
    getServiceTimeUnits() {
        var deferred = this.$q.defer();
        let serviceUnitTypes = this.$_cache.getTimeUnits();
        if (!!serviceUnitTypes) {
            deferred.resolve(serviceUnitTypes);
        } else {
            this.$_api.getEnterpriseServiceUnitTypes().then(
                (s) => {
                    let serviceUnitTypes = s;
                    this.$_cache.setTimeUnits(serviceUnitTypes);
                    deferred.resolve(serviceUnitTypes);
                },
                e => {
                    console.log('error while fetching service unit types');
                    console.log(e);
                    deferred.reject(e)
                }
            );

        }
        return deferred.promise;

    }

    getTimeUnitsById(unitType, unitId) {
        var deferred = this.$q.defer();
        this.getServiceTimeUnits().then((s) => {
            let serviceUnitTypes = s;
            for (var i = 0; i < serviceUnitTypes[unitType].length; i++) {
                if (serviceUnitTypes[unitType][i].unitId == unitId) {
                    deferred.resolve(serviceUnitTypes[unitType][i]);
                }
            }
        })


        return deferred.promise;
    }

    manageServices = (page: string,reload?) => {
        // If the forms module is already loaded, go directly to the state. Otherwise, use the gateway.
        if (this.$ocLazyLoad.isLoaded('eCareVault.ecvServices')) {
            if(reload){
                this.$state.go('parent.services.manage', { page: page }, { reload: true });
                return;
            }
            this.$state.go('parent.services.manage', { page: page });
        } else {
            this.$state.go('services-load', { page: page });
        }
    }

    viewCurrentService = (serviceId:number,reload?) => {
        if (this.$ocLazyLoad.isLoaded('eCareVault.ecvServices')) {
            if(reload){
                this.$state.go('parent.services.view', {serviceId: serviceId}, { reload: true });
                return;
            }
            this.$state.go('parent.services.view', {serviceId: serviceId});
        } else {
            this.$state.go('services-load', { serviceId: serviceId });
        }
    }

    viewCurrentServiceNote = (serviceNoteId:number , serviceId : number ,reload?) => {
        if (this.$ocLazyLoad.isLoaded('eCareVault.ecvServices')) {
            if(reload){
                this.$state.go('parent.services.view', { serviceId: serviceId, serviceNoteId: serviceNoteId }, { reload: true });
                return;
            }
            this.$state.go('parent.services.view', { serviceId: serviceId, serviceNoteId: serviceNoteId });
        } else {
            this.$state.go('services-load', { serviceId: serviceId, serviceNoteId: serviceNoteId });
        }
    }

}

angular.module('eCareVault.common.services')
    .service('ServiceManager', ServiceManager);
